import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import DoctorNylasCallbackPage from './DoctorNylasCallbackPage.js';

export default WithGASetup(DoctorNylasCallbackPage, AuthContext);
